import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

interface UseMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentRejectProps {
  establishmentChoiceEntryId: string;
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject = ({
  establishmentChoiceEntryId,
  options,
}: UseMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentRejectProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation<void, AxiosError, any>({
    mutationKey: ['maintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject'],
    mutationFn: (data) => privateAxios.put(`/maintenance/establishment_choice/manual_entry_proposals/${establishmentChoiceEntryId}/establishment_reject`, {
      establishment_rejected_reason: data.establishment_rejected_reason
    }),
    ...options as any
  });
}
